const page = () => import('@/pages/users/page-users');
const rolePermissions = () => import('@/pages/users/role-permissions');
const userPermissions = () => import('@/pages/users/user-permissions');

export default [
	{ path: '/users', name: 'users', component: page, meta: { title: 'Usuarios', noChangeCompany: true } },
	{ path: '/users/new', name: 'users-new', component: page, meta: { title: 'Nuevo usuario', noChangeCompany: true } },
	{ path: '/users/link', name: 'users-link', component: page, meta: { title: 'Vincular usuario de ACL', noChangeCompany: true } },
	{ path: '/users/permissions', name: 'role-permissions', component: rolePermissions, meta: { title: 'Permisos por rol', noChangeCompany: true } },
	{ path: '/users/:id/permissions', name: 'user-permissions', component: userPermissions, meta: { title: 'Permisos del usuario', noChangeCompany: true } },
	{ path: '/users/:id/edit', name: 'users-edit', component: page, meta: { title: 'Editar usuario', noChangeCompany: true } },
	{ path: '/users/:id/assign-companies', name: 'users-companies', component: page, meta: { title: 'Empresas asignadas', noChangeCompany: true } },
];



// WEBPACK FOOTER //
// ./src/router/users.js